<template>
    <div>
        <v-card
                v-if="reply"
                flat
                color="transparent"
        >
            <v-list-item
                    avatar
                    v-if="reply.author"
            >
                <v-list-item-avatar>
                    <img :src="avatar">
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>
                        <span class="comment-user-name">{{userName}}</span>
                        <span class="comment-date-moment"> | {{date}}</span>
                    </v-list-item-title>
                </v-list-item-content>
                <div v-if="imTheAuthor && !deleted" class="text-right">
                    <v-icon color="accent" @click="deleteComment">delete</v-icon>
                </div>
            </v-list-item>

            <v-sheet color="transparent" class="pa-2 mb-1 text-left">
                <div class="speech-bubble">
                    <p>{{reply.comment}}</p>

                    <div class="deleting-overlay" v-show="deleting">
                        <v-progress-circular color="accent" :indeterminate="true" :size="20" :width="2"></v-progress-circular>
                    </div>

                    <div v-if="deleted" class="deleted-overlay">
                        <span class="--text-white">Este comentario ha sido eliminado.</span>
                        <v-icon class="ml-1" color="accent">far fa-sad-tear</v-icon>
                    </div>

                </div>
            </v-sheet>

            <v-divider class="mt-2 mb-2"></v-divider>

        </v-card>

        <kimsa-confirm
                ref="deleteDialog"
                title="Eliminar Comentario"
                :content="`¿Segur${currentUser && currentUser.gender === 'f' ? 'a' : 'o'} que quieres eliminar este comentario?`"
                v-on:confirm="deleteConfirm"
        ></kimsa-confirm>

    </div>

</template>
<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getFakeAvatar} from '@/utils/Common'

    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['reply', 'wasDeleted'],
        components: {
            KimsaConfirm
        },
        data(){
            return {
                showDeleteDialog: false,
                deleting: false,
                deleted: false
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            deleteComment(){
                var vm = this
                vm.$refs.deleteDialog.show()
            },
            async deleteConfirm(){

                var vm = this
                vm.deleting = true
                const response = await ApiUtils.makeDelete(`providers/rating/replies/${vm.reply.id}`)
                vm.deleting = false

                if(!response.ok){
                    vm.showSnackBar('Ocurrió un error intentando eliminar el comentario')
                    return
                }

                vm.showSnackBar('El comentario ha sido eliminado')

            }
        },
        computed: {
            ...mapState(['currentUser']),
            avatar(){

                var vm = this
                if (!vm.reply || !vm.reply.author) return null
                return vm.reply.author.avatar || getFakeAvatar(vm.reply.author.gender || 'f')

            },
            date(){
                var vm = this
                return vm.$moment(vm.reply.created_at).fromNow()
            },
            userName(){
                var vm = this
                if (!vm.reply || !vm.reply.author) return ''

                return (vm.reply.author.user_name || `${vm.reply.author.first_name} ${vm.reply.author.last_name}.`)

            },
            imTheAuthor(){

                var vm = this
                if (!vm.reply || !vm.reply.author || !vm.currentUser) return false

                return vm.reply.author.id === vm.currentUser.id

            }
        }
    }
</script>
<style scoped>

    .speech-bubble {
        position: relative;
        background: #efefef;
        border-radius: .4em;
        padding: 20px;
    }

    .speech-bubble:after {
        content: '';
        position: absolute;
        top: 0;
        left: 28px;
        width: 0;
        height: 0;
        border: 13px solid transparent;
        border-bottom-color: #efefef;
        border-top: 0;
        margin-left: -13px;
        margin-top: -13px;
    }

    .comment-user-name {
        font-size: 1.1em;
    }

    .comment-date-moment {
        color: #a4a4a4;
        font-size: .9em;
    }

    .deleting-overlay{
        position: absolute;
        background: #efefef;
        border-radius: .4em;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .deleted-overlay{
        position: absolute;
        background: #efefef;
        border-radius: .4em;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: inherit;
    }

</style>
